import './App.css';
import SetForm from './components/SetForm';

function App() {
  return (
    <SetForm />
  );
}

export default App;
